module.exports = __webpack_public_path__ + "img/img_my_bg_0.daa1f60c.jpg";